declare const CONFIG: Record<string, string>;

// Checks if the value has not been interpolated via CI, i.e.
// "#{DILM_API_BASE_URL}#".
function ensureInterpolated(value: string | undefined): string | undefined {
  if (!value || value.match(/^#\{.*\}#$/)) {
    return undefined;
  }
  return value;
}

export const LM_API_BASE_URL =
  ensureInterpolated(CONFIG.LM_API_BASE_URL) ||
  process.env.REACT_APP_LM_API_BASE_URL ||
  "https://development.localmed.com";

export const DI_API_BASE_URL =
  ensureInterpolated(CONFIG.DI_API_BASE_URL) ||
  process.env.REACT_APP_DI_API_BASE_URL ||
  "https://api-qa.dentalintel.com/api";

export const MD_ADMIN_BASE_URL =
  ensureInterpolated(CONFIG.MD_ADMIN_BASE_URL) ||
  process.env.REACT_APP_MD_ADMIN_BASE_URL ||
  "https://dev.modento.io";

export const MD_DASHBOARD_BASE_URL =
  ensureInterpolated(CONFIG.MD_DASHBOARD_BASE_URL) ||
  process.env.REACT_APP_MD_DASHBOARD_BASE_URL ||
  "https://dev-office.modento.io";

export const DILM_API_BASE_URL =
  ensureInterpolated(CONFIG.DILM_API_BASE_URL) ||
  process.env.REACT_APP_DILM_API_BASE_URL ||
  "https://dilm-qa.dentalintel.com";

export const SALESFORCE_BASE_URL =
  ensureInterpolated(CONFIG.SALESFORCE_BASE_URL) ||
  process.env.REACT_APP_SALESFORCE_BASE_URL ||
  "https://dentalintel--sandboxsha.my.salesforce.com";

export const SESSION_EXPIRES_SECONDS =
  ensureInterpolated(CONFIG.SESSION_EXPIRES_SECONDS) ||
  process.env.REACT_APP_SESSION_EXPIRES_SECONDS ||
  "43200";

export const TOKEN_EXPIRES_SECONDS =
  ensureInterpolated(CONFIG.TOKEN_EXPIRES_SECONDS) ||
  process.env.REACT_APP_TOKEN_EXPIRES_SECONDS ||
  "3300";

export const MICROSOFT_SIGN_IN_TENANT =
  ensureInterpolated(CONFIG.MICROSOFT_SIGN_IN_TENANT) ||
  process.env.REACT_APP_MICROSOFT_SIGN_IN_TENANT ||
  "c614e352-a0c2-45b6-bffc-434918cdac9b";

export const FIREBASE_API_KEY =
  ensureInterpolated(CONFIG.FIREBASE_API_KEY) ||
  process.env.REACT_APP_FIREBASE_API_KEY ||
  "";

export const FIREBASE_AUTH_DOMAIN =
  ensureInterpolated(CONFIG.FIREBASE_AUTH_DOMAIN) ||
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
  "auth-e8f83.firebaseapp.com";

export const FIREBASE_PROJECT_ID =
  ensureInterpolated(CONFIG.FIREBASE_PROJECT_ID) ||
  process.env.REACT_APP_FIREBASE_PROJECT_ID ||
  "auth-e8f83";

export const FIREBASE_STORAGE_BUCKET =
  ensureInterpolated(CONFIG.FIREBASE_STORAGE_BUCKET) ||
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
  "auth-e8f83.appspot.com";

export const FIREBASE_MESSAGE_SENDER_ID =
  ensureInterpolated(CONFIG.FIREBASE_MESSAGE_SENDER_ID) ||
  process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID ||
  "300675284724";

export const FIREBASE_APP_ID =
  ensureInterpolated(CONFIG.FIREBASE_APP_ID) ||
  process.env.REACT_APP_FIREBASE_APP_ID ||
  "1:300675284724:web:d2c0c60abf696d45c4a8a1";

export const FIREBASE_MEASUREMENT_ID =
  ensureInterpolated(CONFIG.FIREBASE_MEASUREMENT_ID) ||
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ||
  "G-LQW8FC7588";
